import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Phone, Building2, BarChart3, Settings, LogOut, Key, Receipt, Bell } from 'lucide-react';

export default function SuperAdminDashboard() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  // Verificar se o usuário é super admin
  if (user?.role !== 'super_admin') {
    navigate('/waba');
    return null;
  }

  const menuItems = [
    {
      title: 'Gerenciar Empresas',
      description: 'Criar, visualizar e gerenciar empresas do sistema',
      icon: Building2,
      path: '/admin/tenants',
      color: 'bg-blue-500',
    },
    {
      title: 'Gerenciar Contas WABA',
      description: 'Conectar e gerenciar contas WhatsApp Business API',
      icon: Phone,
      path: '/admin/waba',
      color: 'bg-green-500',
    },
    {
      title: 'Relatórios',
      description: 'Visualizar estatísticas e relatórios do sistema',
      icon: BarChart3,
      path: '/admin/reports',
      color: 'bg-purple-500',
    },
    {
      title: 'Configurações',
      description: 'Configurações gerais do sistema',
      icon: Settings,
      path: '/admin/settings',
      color: 'bg-orange-500',
    },
    {
      title: 'API Keys',
      description: 'Gerenciar chaves de API para integrações externas',
      icon: Key,
      path: '/admin/api-keys',
      color: 'bg-yellow-500',
    },
    {
      title: 'Gerenciar Faturas',
      description: 'Visualizar e atualizar status de faturas dos tenants',
      icon: Receipt,
      path: '/admin/invoices',
      color: 'bg-teal-500',
    },
    {
      title: 'Notificações',
      description: 'Criar e gerenciar avisos para os usuários do sistema',
      icon: Bell,
      path: '/admin/notifications',
      color: 'bg-indigo-500',
    },
  ];

  return (
    <div className="min-h-screen bg-bg-1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Header */}
        <div className="mb-8 flex justify-between items-start">
          <div>
            <h1 className="text-3xl font-bold text-text-1">
              Painel do Super Administrador
            </h1>
            <p className="mt-2 text-text-2">
              Bem-vindo, {user?.name}. Gerencie o sistema completo.
            </p>
          </div>
          <button
            onClick={() => {
              logout();
              navigate('/login');
            }}
            className="flex items-center gap-2 px-4 py-2 bg-danger hover:bg-danger/90 text-white rounded-lg transition-colors"
          >
            <LogOut className="w-4 h-4" />
            Sair
          </button>
        </div>

        {/* Menu Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {menuItems.map((item) => {
            const Icon = item.icon;
            return (
              <button
                key={item.path}
                onClick={() => navigate(item.path)}
                className="bg-bg-2 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200 p-6 text-left group"
              >
                <div className="flex items-start space-x-4">
                  <div className={`${item.color} p-3 rounded-lg text-white group-hover:scale-110 transition-transform`}>
                    <Icon className="w-6 h-6" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-lg font-semibold text-text-1 group-hover:text-accent-1 transition-colors">
                      {item.title}
                    </h3>
                    <p className="mt-1 text-sm text-text-2">
                      {item.description}
                    </p>
                  </div>
                </div>
              </button>
            );
          })}
        </div>

        {/* Quick Stats */}
        <div className="mt-12">
          <h2 className="text-xl font-semibold text-text-1 mb-4">
            Estatísticas Rápidas
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <div className="bg-bg-2 rounded-lg shadow p-6">
              <div className="text-sm text-text-2">Total de Empresas</div>
              <div className="text-2xl font-bold text-text-1 mt-2">-</div>
            </div>
            <div className="bg-bg-2 rounded-lg shadow p-6">
              <div className="text-sm text-text-2">Total de Usuários</div>
              <div className="text-2xl font-bold text-text-1 mt-2">-</div>
            </div>
            <div className="bg-bg-2 rounded-lg shadow p-6">
              <div className="text-sm text-text-2">Empresas Ativas</div>
              <div className="text-2xl font-bold text-text-1 mt-2">-</div>
            </div>
            <div className="bg-bg-2 rounded-lg shadow p-6">
              <div className="text-sm text-text-2">Empresas em Trial</div>
              <div className="text-2xl font-bold text-text-1 mt-2">-</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
